import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-scholarship',
    templateUrl: './scholarship.component.html',
    styleUrls: ['./scholarship.component.scss']
})
export class ScholarshipComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Scholarship: Empowering Students with Financial Support');
        this.meta.updateTag({
            name: 'description',
            content: `Explore ARNI Scholarship opportunities, designed to support talented students with financial assistance, making education more accessible and achievable.`
        });
    }

}
